module.exports = __webpack_public_path__ + "media/images/icons/filled/calendar-db50306abb739022c9ce1d6b48541d3a.svg";